import { render, staticRenderFns } from "./propertiesForm.vue?vue&type=template&id=1a839b62&scoped=true&"
import script from "./propertiesForm.vue?vue&type=script&lang=js&"
export * from "./propertiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a839b62",
  null
  
)

export default component.exports